export const TAGS_QUERY_KEY = 'tags'
export const ARCHIVED_TAGS_QUERY_KEY = 'archivedTags'
